module.exports = __webpack_public_path__ + "static/media/nibrtconcept.f2aa3094.png";